import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Button } from "@mui/material";
import CustomPagination from "../../components/CustomPagination";
import ButterflyEffectTable from "./butterflyEffectTable";
import FilterMenu from "../../components/filterMenu";

const ManageButterflyEffect = () => {
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <h1>Butterfly Effect</h1>
          <div className="right_s">
            <SearchBar searchTerm={""} placeholder={"Search "} />
            <Button className="btn btn_primary"><img src="/static/images/export_icon.svg" alt="icon" /> Export Data</Button>
          <FilterMenu />
          </div>  
        </div>

        <div className="cards table_cards v2">
          <ButterflyEffectTable />
        </div>
        
      </MainContainer>
    </>
  );
};

export default ManageButterflyEffect;
